import {createQueryKeys} from "@lukemorales/query-key-factory";

export const Misc = createQueryKeys('misc', {
    userGuide: () => ['user-guide'],
});
